/**
 * Shared color palettes and formatting helpers for Statistics charts
 */

export const COLOR_PALETTE_20: string[] = [
  '#8CB9FE', // 1. Từ 0 - dưới 7 tháng tuổi (Light sky blue)
  '#5BA3FC', // 2. Từ 7 – dưới 9 tháng tuổi (Dodger blue)
  '#3B95FA', // 3. Từ 9 – dưới 12 tháng tuổi (Vivid azure blue)
  '#3AA7C0', // 4. Từ 12 – dưới 18 tháng tuổi (Teal / turquoise blue)
  '#5EBD88', // 5. Từ 18 – dưới 24 tháng tuổi (Sea green)
  '#8EE37A', // 6. Từ 24 – dưới 36 tháng tuổi (Light lime green)
  '#88DAA4', // 7. Từ 36 – dưới 60 tháng tuổi (Mint green)
  '#7EBEA7', // 8. Từ 60 – dưới 72 tháng tuổi (Sage green)
  '#FEDC77', // 9. Từ 72 tháng – dưới 8 tuổi (Pale soft yellow)
  '#FEBA69', // 10. Từ 8 – dưới 10 tuổi (Peach / light amber)
  '#FFAA33', // 11. Từ 10 – dưới 12 tuổi (Golden amber)
  '#F78320', // 12. Từ 12 – dưới 15 tuổi (Vivid orange)
  '#FCA2A7', // 13. Từ 15 – tròn 19 tuổi (Salmon / coral pink)
  '#F88AB9', // 14. Từ trên 19 tuổi - dưới 20 tuổi (Rose pink)
  '#F36577', // 15. Từ 20 - dưới 30 tuổi (Watermelon red)
  '#D63B50', // 16. 30 tuổi (Crimson red)
  '#D7C3FE', // 17. Từ 31 - dưới 50 tuổi (Soft lavender purple)
  '#F7A5EC', // 18. Từ 50 - dưới 70 tuổi (Lilac orchid pink)
  '#81A1FD', // 19. Từ ≥70 tuổi (Periwinkle blue)
  '#B8B8B8', // 20. Không có thông tin (Neutral gray)
];

export const AGE_GROUP_COLORS: Record<string, string> = {
  'Từ 0 - dưới 7 tháng tuổi': '#8CB9FE',
  'Từ 7 – dưới 9 tháng tuổi': '#5BA3FC',
  'Từ 7 - dưới 9 tháng tuổi': '#5BA3FC',
  'Từ 9 – dưới 12 tháng tuổi': '#3B95FA',
  'Từ 9 - dưới 12 tháng tuổi': '#3B95FA',
  'Từ 12 – dưới 18 tháng tuổi': '#3AA7C0',
  'Từ 12 - dưới 18 tháng tuổi': '#3AA7C0',
  'Từ 18 – dưới 24 tháng tuổi': '#5EBD88',
  'Từ 18 - dưới 24 tháng tuổi': '#5EBD88',
  'Từ 24 – dưới 36 tháng tuổi': '#8EE37A',
  'Từ 24 - dưới 36 tháng tuổi': '#8EE37A',
  'Từ 36 – dưới 60 tháng tuổi': '#88DAA4',
  'Từ 36 - dưới 60 tháng tuổi': '#88DAA4',
  'Từ 60 – dưới 72 tháng tuổi': '#7EBEA7',
  'Từ 60 - dưới 72 tháng tuổi': '#7EBEA7',
  'Từ 72 tháng – dưới 8 tuổi': '#FEDC77',
  'Từ 72 tháng - dưới 8 tuổi': '#FEDC77',
  'Từ 8 – dưới 10 tuổi': '#FEBA69',
  'Từ 8 - dưới 10 tuổi': '#FEBA69',
  'Từ 10 – dưới 12 tuổi': '#FFAA33',
  'Từ 10 - dưới 12 tuổi': '#FFAA33',
  'Từ 12 – dưới 15 tuổi': '#F78320',
  'Từ 12 - dưới 15 tuổi': '#F78320',
  'Từ 15 – tròn 19 tuổi': '#FCA2A7',
  'Từ 15 - tròn 19 tuổi': '#FCA2A7',
  'Từ trên 19 tuổi - dưới 20 tuổi': '#F88AB9',
  'Từ 20 - dưới 30 tuổi': '#F36577',
  '30 tuổi': '#D63B50',
  'Từ 31 - dưới 50 tuổi': '#D7C3FE',
  'Từ 50 - dưới 70 tuổi': '#F7A5EC',
  'Từ ≥70 tuổi': '#81A1FD',
  'Từ >=70 tuổi': '#81A1FD',
  'Không có thông tin': '#B8B8B8',
  AGE_0_7M: '#8CB9FE',
  AGE_7_9M: '#5BA3FC',
  AGE_9_12M: '#3B95FA',
  AGE_12_18M: '#3AA7C0',
  AGE_18_24M: '#5EBD88',
  AGE_24_36M: '#8EE37A',
  AGE_36_60M: '#88DAA4',
  AGE_60_72M: '#7EBEA7',
  AGE_72M_8Y: '#FEDC77',
  AGE_8_10Y: '#FEBA69',
  AGE_10_12Y: '#FFAA33',
  AGE_12_15Y: '#F78320',
  AGE_15_19Y: '#FCA2A7',
  AGE_19_20Y: '#F88AB9',
  AGE_20_30Y: '#F36577',
  AGE_30Y: '#D63B50',
  AGE_31_50Y: '#D7C3FE',
  AGE_50_70Y: '#F7A5EC',
  AGE_GE_70Y: '#81A1FD',
  NO_INFO: '#B8B8B8',
};

export const GENDER_COLORS: Record<string, string> = {
  Nam: '#1890ff',
  'Nữ': '#FAA5EB',
  'Không có thông tin': '#bfbfbf',
};

export const PROVINCE_COLORS: Record<string, string> = {
  'Tuyên Quang': '#7EBEA7',
  'Cao Bằng': '#A8C4B8',
  'Lai Châu': '#D4E79E',
  'Lào Cai': '#486856',
  'Thái Nguyên': '#5EBD88',
  'Điện Biên': '#88DAA4',
  'Lạng Sơn': '#3AA7C0',
  'Sơn La': '#4FBBD2',
  'Phú Thọ': '#84D4E4',
  'Bắc Ninh': '#8C6551',
  'Quảng Ninh': '#BA927C',
  'TP. Hà Nội': '#F86B7C',
  'Hà Nội': '#F86B7C',
  'TP Hà Nội': '#F86B7C',
  'TP. Hải Phòng': '#BA967A',
  'Hải Phòng': '#BA967A',
  'TP Hải Phòng': '#BA967A',
  'Hưng Yên': '#8E7E74',
  'Ninh Bình': '#D83A64',
  'Thanh Hoá': '#E84D8A',
  'Thanh Hóa': '#E84D8A',
  'Nghệ An': '#FCA2A7',
  'Hà Tĩnh': '#E8B4D4',
  'Quảng Trị': '#F78320',
  'TP. Huế': '#FEBA69',
  'Huế': '#FEBA69',
  'Thừa Thiên Huế': '#FEBA69',
  'TP. Đà Nẵng': '#FEDC77',
  'Đà Nẵng': '#FEDC77',
  'TP Đà Nẵng': '#FEDC77',
  'Quảng Ngãi': '#7B52AB',
  'Gia Lai': '#9D6BCF',
  'Đắk Lắk': '#5A77DF',
  'Đắc Lắk': '#5A77DF',
  'Đắk Nông': '#6E88E8',
  'Đắc Nông': '#6E88E8',
  'Khánh Hoà': '#A8B6F9',
  'Khánh Hòa': '#A8B6F9',
  'Lâm Đồng': '#C8D4FC',
  'Đồng Nai': '#BCA8E8',
  'Tây Ninh': '#3B95FA',
  'TP. Hồ Chí Minh': '#2B7888',
  'Hồ Chí Minh': '#2B7888',
  'TP Hồ Chí Minh': '#2B7888',
  'Đồng Tháp': '#5BA3FC',
  'An Giang': '#8CB9FE',
  'Vĩnh Long': '#3D4856',
  'TP. Cần Thơ': '#6E7A8A',
  'Cần Thơ': '#6E7A8A',
  'TP Cần Thơ': '#6E7A8A',
  'Cà Mau': '#9AA6B5',
  'Bình Dương': '#20B2AA',
  'Bình Thuận': '#5EBD88',
  'Bà Rịa - Vũng Tàu': '#3AA7C0',
  'Bạc Liêu': '#8EE37A',
  'Bắc Kạn': '#8CB9FE',
  'Hà Nam': '#F86B7C',
  'Nam Định': '#E84D8A',
  'Thái Bình': '#BA967A',
  'Hải Dương': '#BA927C',
  'Bắc Giang': '#8C6551',
  'Hòa Bình': '#4FBBD2',
  'Yên Bái': '#486856',
  'Hà Giang': '#7EBEA7',
  'Quảng Bình': '#F78320',
  'Bình Định': '#7B52AB',
  'Phú Yên': '#A8B6F9',
  'Ninh Thuận': '#D83A64',
  'Bình Phước': '#2B7888',
  'Long An': '#3B95FA',
  'Tiền Giang': '#5BA3FC',
  'Bến Tre': '#8CB9FE',
  'Trà Vinh': '#3D4856',
  'Hậu Giang': '#6E7A8A',
  'Sóc Trăng': '#9AA6B5',
  'Kiên Giang': '#8CB9FE',
  'Kon Tum': '#9D6BCF',
  'Không có thông tin': '#B8B8B8',
};

export const PROVINCE_PALETTE: string[] = [
  '#7EBEA7', '#A8C4B8', '#D4E79E', '#486856', '#5EBD88', '#88DAA4',
  '#3AA7C0', '#4FBBD2', '#84D4E4', '#8C6551', '#BA927C', '#F86B7C',
  '#BA967A', '#8E7E74', '#D83A64', '#E84D8A', '#FCA2A7', '#E8B4D4',
  '#F78320', '#FEBA69', '#FEDC77', '#7B52AB', '#9D6BCF', '#5A77DF',
  '#A8B6F9', '#C8D4FC', '#BCA8E8', '#3B95FA', '#2B7888', '#5BA3FC',
  '#8CB9FE', '#3D4856', '#6E7A8A', '#9AA6B5',
];

export const PRIMARY_BAR_COLOR = '#80d8a2';

export const FEATURE_COLORS: Record<string, string> = {
  'Trang chủ': '#5B8FF9',
  'Theo dõi sức khoẻ': '#73D89C',
  'Theo dõi sức khỏe': '#73D89C',
  'Tư vấn sức khoẻ': '#FA983A',
  'Tư vấn sức khỏe': '#FA983A',
  'Kiểm tra & Lên bữa ăn': '#FF8596',
  'Nhật ký sức khoẻ': '#FF4D4F',
  'Nhật ký sức khỏe': '#FF4D4F',
  'Mục tiêu cho bạn': '#B37FEB',
  'Mục tiêu của bạn': '#B37FEB',
  'Cẩm nang cho bạn': '#66E0E5',
  'Khác': '#A6A6A6',
  HOME: '#5B8FF9',
  HEALTH_MONITORING: '#73D89C',
  HEALTH_CONSULT: '#FA983A',
  MEAL_PLANNER: '#FF8596',
  HEALTH_DIARY: '#FF4D4F',
  GOALS: '#B37FEB',
  HANDBOOK: '#66E0E5',
  OTHER: '#A6A6A6',
};

export const formatNumber = (num: number): string => {
  return (num || 0).toLocaleString('vi-VN');
};

/**
 * Automatically wraps category label text into multiple lines so that labels never collide or overlap.
 * Uses category count to dynamically determine max characters per line.
 */
export const formatCategoryAxisLabel = (value: string, categoryCountOrMaxChars?: number): string => {
  if (!value) return '';
  if (value.includes('\n')) return value;

  // Determine max characters per line based on total category count or explicit maxChars
  let maxChars = 11;

  if (typeof categoryCountOrMaxChars === 'number') {
      if (categoryCountOrMaxChars <= 30 && categoryCountOrMaxChars >= 1) {
      if (categoryCountOrMaxChars >= 16) {
        maxChars = 7;
      } else if (categoryCountOrMaxChars >= 12) {
        maxChars = 9;
      } else if (categoryCountOrMaxChars >= 8) {
        maxChars = 12;
      } else {
        maxChars = 15;
      }

    } else {
      maxChars = categoryCountOrMaxChars;
    }
  }

  // Ensure hyphens, en-dashes and slashes have clean separation for wrapping
  const normalizedValue = value
    .replace(/\s*[–—]\s*/g, ' – ')
    .replace(/\s*-\s*/g, ' - ')
    .replace(/\s*\/\s*/g, ' / ')
    .trim();

  const words = normalizedValue.split(/\s+/);
  const lines: string[] = [];
  let currentLine = '';

  for (const word of words) {
    if (!currentLine) {
      currentLine = word;
    } else if ((currentLine + ' ' + word).length <= maxChars) {
      currentLine += ' ' + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  if (currentLine) {
    lines.push(currentLine);
  }
  return lines.join('\n');
};

